

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// UPDATESTAKENOWSECTIONFORREAPPROVAL
// UPDATESTAKENOWSECTIONFORREAPPROVAL


const UPDATESTAKENOWSECTIONFORREAPPROVAL= createAsyncThunk(
  "updateStakeNowSectionForReApproval/updateStakeNowSectionForReApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateStakeNowSectionForReApprovalSlice = createSlice({
  name: "updateStakeNowSectionForReApprovalSlice",
  initialState: {
    updateStakeNowSectionForReApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateStakeNowSectionForReApproval: (state) => {
        state.updateStakeNowSectionForReApproval.loading = false
        state.updateStakeNowSectionForReApproval.error = false
        state.updateStakeNowSectionForReApproval.data = []
        state.updateStakeNowSectionForReApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATESTAKENOWSECTIONFORREAPPROVAL.fulfilled, (state, action) => {
      state.updateStakeNowSectionForReApproval = {
        ...state.updateStakeNowSectionForReApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATESTAKENOWSECTIONFORREAPPROVAL.pending, (state, action) => {
      state.updateStakeNowSectionForReApproval = {
        ...state.updateStakeNowSectionForReApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATESTAKENOWSECTIONFORREAPPROVAL.rejected, (state, action) => {
      state.updateStakeNowSectionForReApproval = {
        ...state.updateStakeNowSectionForReApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateStakeNowSectionForReApprovalAction = {
    UPDATESTAKENOWSECTIONFORREAPPROVAL,
};

export { updateStakeNowSectionForReApprovalAction };
export default updateStakeNowSectionForReApprovalSlice.reducer;
export const {setInitialStateOfupdateStakeNowSectionForReApproval} = updateStakeNowSectionForReApprovalSlice.actions
